module.exports = __webpack_public_path__ + "img/second-section-bg.7a36d92b.png";